(function () {
  'use strict';

  angular.module('unit.status').factory('UnitStatus', UnitStatus);

  UnitStatus.$inject = ['$resource'];

  function UnitStatus($resource) {
    return $resource(
      '/api/unit/status',
      {},
      {
        get: { method: 'GET', url: '/api/unit/status', isArray: true },
        updateStatus: {
          method: 'POST',
          url: '/api/unit/:unit_id/update_status',
        },
      },
    );
  }
})();
